import { configureStore } from "@reduxjs/toolkit";

import journeyReducer from "./journeySlice";
import authReducer from "./authSlice";
import schemeReducer from "./schemeSlice";


export const store = configureStore({

    reducer: {
        journey: journeyReducer,
        auth: authReducer,
        scheme: schemeReducer,
    },

});

export type RootState =
    ReturnType<typeof store.getState>;

export type AppDispatch =
    typeof store.dispatch;